import { utils, jsbridgeNew, Actions } from "msb-public-library";

// 解构href参数
// '?a=1&b=2'
export function searchQuery(search = location.search) {
  const queryStr = search.split("?").pop();
  if (!queryStr) return {};
  return queryStr.split("&").reduce((prev, cur) => {
    const [key, value] = cur.split("=");
    return {
      ...prev,
      [key]: decodeURIComponent(value)
    };
  }, {});
}

// 合成海报
export function makePoster({
  imgUrl,
  qrcodeUrl,
  left,
  top,
  width = 200,
  height = 200,
  scale = 1, //放大倍数
  callback = () => {}
}) {
  let myImage = new Image();
  myImage.crossOrigin = "Anonymous";
  myImage.onload = function () {
    let canvas = document.createElement("canvas");
    canvas.width = myImage.width * scale;
    canvas.height = myImage.height * scale;
    let context = canvas.getContext("2d");
    context.scale(scale, scale);
    context.rect(0, 0, canvas.width, canvas.height);
    context.fillStyle = "#fff";
    context.fill();
    context.drawImage(myImage, 0, 0, myImage.width, myImage.height);
    let myImage2 = new Image();
    myImage2.crossOrigin = "Anonymous";
    myImage2.onload = function () {
      context.drawImage(myImage2, left, top, width, height);
      callback(canvas.toDataURL("image/jpeg"));
    };
    myImage2.src = `${qrcodeUrl}?x-oss-process=image/interlace,1/resize,w_750/quality,q_90/format,jpg`;
  };
  myImage.src = `${imgUrl}?x-oss-process=image/interlace,1/resize,w_750/quality,q_90/format,jpg`;
}

//写cookies
export function setCookie(name, value, day) {
  if (day !== 0) {
    // 当设置的时间等于0时，不设置expires属性，cookie在浏览器关闭后删除
    var expires = day * 24 * 60 * 60 * 1000;
    var date = new Date(+new Date() + expires);
    document.cookie = `${name}=${escape(
      value
    )};expires=${date.toUTCString()};path=/`;
  } else {
    document.cookie = `${name}=${escape(value)};path=/`;
  }
}
//读取cookies
export function getCookie(name) {
  // 获取cookies
  let strCookie = document.cookie;
  let arrCookie = strCookie.split("; ");
  for (var i = 0; i < arrCookie.length; i++) {
    let arr = arrCookie[i].split("=");
    if (name == arr[0]) {
      return arr[1];
    }
  }
  return "";
}

//删除cookies
export function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}
// 去除获取及上传路径中的uploadId
function strsplit(str) {
  const index = str.indexOf("?uploadId=");
  return index === -1 ? str : str.substr(0, index);
}
// 获取邀请有礼的截图状态
export function getCheckStatus(data) {
  //           本月是否分享过      是否显示上传按钮           上传分享截图信息         审核状态                        分享的图片
  // 提交       is_shared == 1 && showUploadButton == 1
  // 审核中      is_shared == 2 && showUploadButton == 2  && shareInfo = {}   && shareInfo.check_status = 1   shareInfo.share_img
  // 查看奖励    is_shared == 2 && showUploadButton == 2  && shareInfo = {}   && shareInfo.check_status = 3   shareInfo.share_img
  // 重新上传    is_shared == 2 && showUploadButton == 1  && shareInfo = {}   && shareInfo.check_status = 2
  // 异常中的审核中   is_shared == 2 && showUploadButton == 2  && shareInfo = {}   && shareInfo.check_status = 4   shareInfo.share_img

  // is_shared 1 是未分享  2 是分享过
  // showUploadButton  1 显示上传图片按钮  2 是不显示上传图片按钮
  // check_status  0   1 待审核  2 审核失败  3 审核成功 4 审核异常
  // 提交
  if (data.is_shared == 1 && data.showUploadButton == 1) {
    return { status: 0, src: "" };
  }

  if (
    data.is_shared == 2 &&
    data.showUploadButton == 2 &&
    !(data.shareInfo instanceof Array) &&
    data.shareInfo.check_status == 1
  ) {
    return {
      status: 1,
      src: strsplit(data.shareInfo.share_img)
    };
  }
  if (
    data.is_shared == 2 &&
    data.showUploadButton == 2 &&
    !(data.shareInfo instanceof Array) &&
    data.shareInfo.check_status == 3
  ) {
    return {
      status: 2,
      src: strsplit(data.shareInfo.share_img)
    };
  }
  if (
    data.is_shared == 2 &&
    data.showUploadButton == 2 &&
    !(data.shareInfo instanceof Array) &&
    data.shareInfo.check_status == 4
  ) {
    return {
      status: 1,
      src: strsplit(data.shareInfo.share_img)
    };
  }
  if (
    data.is_shared == 2 &&
    data.showUploadButton == 1 &&
    !(data.shareInfo instanceof Array) &&
    data.shareInfo.check_status == 2
  ) {
    return { status: 3, src: "" };
  }
  return { status: 0, src: "" };
}
// 删除url中参数
export function removeURLParam(url, parameter) {
  let urlparts = url.split("?");
  if (urlparts.length >= 2) {
    let prefix = encodeURIComponent(parameter) + "=";
    let pars = urlparts[1].split(/[&;]/g);
    for (let i = pars.length; i-- > 0; ) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        // 存在则删除
        pars.splice(i, 1);
      }
    }
    return urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
  }
  return url;
}
// url后追加参数
export function addURLParam(uri, key, value) {
  if (!value) {
    return uri;
  }
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf("?") !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + value + "$2");
  } else {
    return uri + separator + key + "=" + value;
  }
}

// app/微信获取userId
export function getUserId() {
  let querys = {};
  window.location.search.replace(
    /([^?&=]+)=([^&]+)/g,
    (_, k, v) => (querys[k] = v)
  );
  // 兼容不同页面命名
  let userId =
    querys.userId ||
    querys.userid ||
    querys.useid ||
    querys.uid ||
    getCookie("userId");

  if (!userId || userId === "undefined") {
    userId = utils.parseQuery(window.navigator.userAgent).userid;
  }
  console.log(userId, "用户id");
  return userId;
}
/**
 * 用户未登录跳转app原生登录
 * @param {string} url 登录成功之后跳转的页面,必须是vue的path
 * @param {object} params 登录成功之后跳转的页面传的参数，将会在链接中展示
 */
export const goLogin = ({ url, params }) => {
  // app环境
  if (utils.client.msb1v1app) {
    if (
      utils.client.ios ||
      (utils.parseQuery(navigator.userAgent).buildversion >= 260000 &&
        utils.client.android)
    ) {
      jsbridgeNew &&
        jsbridgeNew[Actions.gotoLogin]({
          callbackName: "sendUserInfo",
          callbackFn: val => {
            if (utils.client.ios) {
              this.$router.replace({
                path: url,
                query: {
                  userId: val.userId,
                  ...params
                }
              });
            }
          }
        });
    }
    // 低版本app只能通过课表管理登录进入，不能回到本页面
    if (
      utils.parseQuery(navigator.userAgent).buildversion < 260000 &&
      utils.client.android
    ) {
      jsbridgeNew && jsbridgeNew[Actions.jumpTimeable]({});
    }
  } else {
    // 微信公众号环境，跳转到登录之后会跳转回来带上userid
    window.location.href =
      window.location.origin +
      "/wxpn/activity.html?path=" +
      "/1v1h5pages" +
      url;
  }
};

/**
 * 用户未登录跳转app原生登录
 * @param {string} url 登录成功之后跳转的页面,必须是vue的path
 * @param {object} params 登录成功之后跳转的页面传的参数，将会在链接中展示
 */
export const commontGoLogin = ({ url, params }) => {
  // app环境
  if (utils.client.msb1v1app) {
    jsbridgeNew &&
      jsbridgeNew[Actions.gotoLogin]({
        callbackName: "sendUserInfo",
        callbackFn: val => {
          if (utils.client.ios) {
            this.$router.replace({
              path: url,
              query: {
                userId: val.userId,
                ...params
              }
            });
          }
        }
      });
  } else {
    // 微信公众号环境，跳转到登录之后会跳转回来带上userid
    window.location.href = `${
      window.location.origin
    }/1v1h5pages/activity/login?referrerPage=${encodeURIComponent(url)}`;
  }
};

/**
 * 小熊app协议调用
 * @param {*} url
 * @param {*} method
 */
export function schemaToApp(url, method) {
  window.location.href = url;
  window.bear = method;
}
// 数组随机 洗牌算法
export const shuffleAlgorithm = function (arr) {
  for (var i = arr.length - 1; i >= 0; i--) {
    var randomIndex = Math.floor(Math.random() * (i + 1));
    var itemAtIndex = arr[randomIndex];
    arr[randomIndex] = arr[i];
    arr[i] = itemAtIndex;
  }
  return arr;
};

/**
 * 防抖
 * @param {*} fn
 * @param {*} delay
 *  @param {*} immediate
 */
export function debounce(fn, delay = 300, immediate) {
  let timer; //设置定时器
  return function () {
    let _this = this,
      arg = arguments;
    if (timer) clearTimeout(timer);
    if (immediate) {
      let callNow = !timer;
      timer = setTimeout(() => {
        timer = null;
      }, delay);
      if (callNow) {
        timer = setTimeout(() => {
          fn.apply(_this, arg);
        }, delay);
      }
    } else {
      timer = setTimeout(() => {
        fn.apply(_this, arg);
      }, delay);
    }
  };
}

/**
 * 节流
 * @param {*} fn
 * @param {*} delay
 */
export function throttle(fn, delay = 50) {
  let timer = Date.now();

  return function () {
    let arg = arguments;
    if (Date.now() - timer > delay) {
      timer = Date.now();
      fn.apply(this, ...arg);
    }
  };
}

/**
 * 多个图片同时加载完成
 * @param {*} imgs 图片列表
 */
export function imgAllLoad(imgs) {
  return new Promise((resolve, reject) => {
    let promiseAll = [];
    if (imgs.length <= 0) return;
    imgs.forEach(item => {
      let p = new Promise(resolve => {
        let img = new window.Image();
        img.crossOrigin = "Anonymous";
        img.src = item;
        img.onload = function () {
          resolve(img);
        };
      });
      promiseAll.push(p);
    });
    Promise.all(promiseAll)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
/**
 * 将图片转成base64
 * @param {*} url 图片url
 */
export function getBase64Image(url) {
  return new Promise((resolve, reject) => {
    let that = this;
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    let image = new Image();
    image.crossOrigin = "Anonymous";
    image.src = url;
    image.onload = function () {
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.drawImage(image, 0, 0, image.width, image.height);
      let dataURL = canvas.toDataURL("image/jpeg", 1.0);
      resolve(dataURL);
    };
  });
}

/**
 * 微信支付
 * @param {*} params
 * appId // 公众号ID，由商户传入
 * timeStamp // 时间戳，自1970年以来的秒数
 * nonceStr // 随机串
 * package // 订单详情扩展字符串
 * signType // 微信签名方式, MD5
 * paySign // 微信签名
 */
export function wxPay(params) {
  return new Promise((resolve, reject) => {
    function onBridgeReady() {
      WeixinJSBridge.invoke("getBrandWCPayRequest", params, function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 支付成功
          resolve();
        } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
          // 取消支付
          reject("cancel");
        } else {
          // 支付失败
          reject("error");
        }
      });
    }
    if (typeof WeixinJSBridge == "undefined") {
      if (document.addEventListener) {
        document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
      } else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
        document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
      }
    } else {
      onBridgeReady();
    }
  });
}

/**
 * 比较app版本号
 * @param {*} version app版本号
 */
export function compareVersion(version) {
  let buildversion = utils.parseQuery(navigator.userAgent).buildversion;
  buildversion = buildversion.length == 5 ? buildversion + "0" : buildversion;
  if (buildversion) {
    return buildversion >= version;
  }
  return false;
}

function filter(str) {
  // 特殊字符转义
  str += ""; // 隐式转换
  str = str.replace(/%/g, "%25");
  str = str.replace(/\+/g, "%2B");
  str = str.replace(/ /g, "%20");
  str = str.replace(/\//g, "%2F");
  str = str.replace(/\?/g, "%3F");
  str = str.replace(/&/g, "%26");
  str = str.replace(/\=/g, "%3D");
  str = str.replace(/#/g, "%23");
  return str;
}
/**
 * 对象转为参数
 */
export function formateObjToParamStr(paramObj) {
  const sdata = [];
  for (let attr in paramObj) {
    sdata.push(`${attr}=${filter(paramObj[attr])}`);
  }
  return sdata.join("&");
}

/**
 * @description: 是否为小程序
 * @return {*}
 */
export const isInWechatMP = () => {
  return (
    (navigator.userAgent.match(/micromessenger/i) &&
      navigator.userAgent.match(/miniprogram/i)) ||
    window.__wxjs_environment === "miniprogram"
  );
};

export const classPackageTypeMap = { 10: "", 11: "", 12: "" };

export const reversedHexToString = hex => {
  let reversedHex = hex.split("").reverse().join("");
  let str = "";
  for (let i = 0; i < reversedHex.length; i += 2) {
    let code = parseInt(reversedHex.substr(i, 2), 16);
    str += String.fromCharCode(code);
  }
  return str;
};

export const appToken = () => {
  let token = "";
  if (utils.client.msb1v1app) {
    token = utils.parseQuery(navigator.userAgent).token;
  } else {
    const cookieToken = getCookie("token");
    token =
      cookieToken && cookieToken.indexOf("Bearer+") > -1
        ? cookieToken.replace("Bearer+", "Bearer ")
        : cookieToken;
    token = token.startsWith('Bearer%20') ? token.replace('Bearer%20', 'Bearer ') : token
  }
  return token;
};
